import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import TopNav from "../containers/navs/Topnav";

import NotificationContainer from "../components/common/react-notifications/NotificationContainer";

class AppLayout extends Component {
  render() {
    // Không sử dụng containerClassnames từ Redux để tránh overlay/dimming
    // từ các class như menu-mobile, sub-show-temporary
    return (
      <div id="app-container" className="menu-hidden">
        <NotificationContainer />
        <TopNav history={this.props.history} isCashier={true} />
        <main className="main-no-sidebar">
          <div
            className="container-fluid"
            style={{ paddingLeft: "45px", paddingRight: "45px" }}
          >
            {this.props.children}
          </div>
        </main>
      </div>
    );
  }
}

export default withRouter(AppLayout);
